// Generated by purs version 0.15.15
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Record_Extra from "../Record.Extra/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var foldMap = /* #__PURE__ */ Data_Foldable.foldMap(Data_Foldable.foldableArray)(Data_Monoid.monoidString);
var intercalate = /* #__PURE__ */ Data_Foldable.intercalate(Data_Foldable.foldableArray)(Data_Monoid.monoidString);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var fromFoldable = /* #__PURE__ */ Data_Array.fromFoldable(Data_List_Types.foldableList);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_List_Types.functorList);
var keys = /* #__PURE__ */ Record_Extra.keys();
var TSType = function (x) {
    return x;
};
var TSRecordField = function (x) {
    return x;
};
var Code = function (x) {
    return x;
};
var semigroupCode = Data_Semigroup.semigroupString;
var append1 = /* #__PURE__ */ Data_Semigroup.append(semigroupCode);
var monoidCode = Data_Monoid.monoidString;
var mempty = /* #__PURE__ */ Data_Monoid.mempty(monoidCode);
var recordToHelperNil = {
    fillFormFieldTypeRecord: function (v) {
        return [  ];
    },
    toHelperRecord: function (v) {
        return mempty;
    }
};
var tyVar = TSType;
var toFillFormTypeAction = {
    fillFormDataType: function (v) {
        return tyVar("unknown");
    }
};
var toFillFormTypeBoolean = {
    fillFormDataType: function (v) {
        return tyVar("boolean");
    }
};
var toFillFormTypeCoordinates = {
    fillFormDataType: function (v) {
        return tyVar("unknown");
    }
};
var toFillFormTypeEntityId = {
    fillFormDataType: function (v) {
        return tyVar("string");
    }
};
var toFillFormTypeForeign = {
    fillFormDataType: function (v) {
        return tyVar("unknown");
    }
};
var toFillFormTypeInt = {
    fillFormDataType: function (v) {
        return tyVar("number");
    }
};
var toFillFormTypeLocale = {
    fillFormDataType: function (v) {
        return tyVar("string");
    }
};
var toFillFormTypeMap = function (dictToFillFormType) {
    return function (dictToFillFormType1) {
        return {
            fillFormDataType: function (v) {
                return tyVar("unknown");
            }
        };
    };
};
var toFillFormTypeMap1 = function (dictToFillFormType) {
    return function (dictToFillFormType1) {
        return {
            fillFormDataType: function (v) {
                return tyVar("unknown");
            }
        };
    };
};
var toFillFormTypeMoney = {
    fillFormDataType: function (v) {
        return tyVar("number");
    }
};
var toFillFormTypeOMap = function (dictToFillFormType) {
    return function (dictToFillFormType1) {
        return {
            fillFormDataType: function (v) {
                return tyVar("unknown");
            }
        };
    };
};
var toFillFormTypeOption = {
    fillFormDataType: function (v) {
        return tyVar("unknown");
    }
};
var toFillFormTypeRational = {
    fillFormDataType: function (v) {
        return tyVar("string");
    }
};
var toFillFormTypeString = {
    fillFormDataType: function (v) {
        return tyVar("string");
    }
};
var toFillFormTypeValue = {
    fillFormDataType: function (v) {
        return tyVar("unknown");
    }
};
var tyStringConstant = function (s) {
    return show(s);
};
var gEnumToFillFormTypeConstr = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    return {
        gdefaultEnumFillFormDataType: function (v) {
            return tyStringConstant(reflectSymbol(Type_Proxy["Proxy"].value));
        }
    };
};
var tyRecord = function (fields) {
    return "{" + (foldMap(function (v) {
        return v + ";";
    })(fields) + "}");
};
var toFillFormTypeUnit = {
    fillFormDataType: function (v) {
        return tyRecord([  ]);
    }
};
var toHelperRecord = function (dict) {
    return dict.toHelperRecord;
};
var toHelperConstructor = function (dict) {
    return dict.toHelperConstructor;
};
var toHelperClassBody = function (dict) {
    return dict.toHelperClassBody;
};
var renderType = function (v) {
    return v;
};
var tyApp = function (f) {
    return function (tys) {
        return f + ("<" + (intercalate(", ")(map(renderType)(tys)) + ">"));
    };
};
var tyArray = function (ty) {
    return renderType(ty) + "[]";
};
var tyIntersection = function (tys) {
    return "(" + (intercalate(" & ")(map(renderType)(tys)) + ")");
};
var tyUnion = function (tys) {
    return "(" + (intercalate(" | ")(map(renderType)(tys)) + ")");
};
var toFillFormTypeTag = function () {
    return function (dictKeys) {
        var keys1 = keys(dictKeys);
        return {
            fillFormDataType: function (v) {
                return tyUnion(fromFoldable(map1(tyStringConstant)(keys1(Type_Proxy["Proxy"].value))));
            }
        };
    };
};
var renderCode = function (v) {
    return v;
};
var recordField = function (label) {
    return function (v) {
        return label + ("?: " + v);
    };
};
var mangleName = function (v) {
    if (v === "submit") {
        return "submit_";
    };
    return Data_String_Common.replaceAll(".")("")(v);
};
var lit = Code;
var ppType = function (v) {
    return lit(v);
};
var toToplevelHelper = function (dictToHelper) {
    var toHelperConstructor1 = toHelperConstructor(dictToHelper);
    return function (name) {
        return append1(lit("public readonly " + (mangleName(name) + " = new ")))(append1(toHelperConstructor1(Type_Proxy["Proxy"].value))(lit("(this, " + (show(name) + ");"))));
    };
};
var toHelperAction = {
    fillFormFieldType: function (v) {
        return tyVar("never");
    },
    toHelperConstructor: function (v) {
        return lit("ActionHelper");
    }
};
var toHelperAsync = {
    fillFormFieldType: function (v) {
        return tyVar("never");
    },
    toHelperConstructor: function (v) {
        return lit("DummyHelper");
    }
};
var toHelperExclusiveTask = {
    fillFormFieldType: function (v) {
        return tyVar("never");
    },
    toHelperConstructor: function (v) {
        return lit("DummyHelper");
    }
};
var toHelperPaginator = {
    fillFormFieldType: function (v) {
        return tyVar("never");
    },
    toHelperConstructor: function (v) {
        return lit("DummyHelper");
    }
};
var toHelperReadOnly$prime = {
    fillFormFieldType: function (v) {
        return tyVar("never");
    },
    toHelperConstructor: function (v) {
        return lit("DummyHelper");
    }
};
var helperBaseClass = function (dict) {
    return dict.helperBaseClass;
};
var gdefaultEnumFillFormDataType = function (dict) {
    return dict.gdefaultEnumFillFormDataType;
};
var gEnumToFillFormTypeSum = function (dictGEnumToFillFormType) {
    var gdefaultEnumFillFormDataType1 = gdefaultEnumFillFormDataType(dictGEnumToFillFormType);
    return function (dictGEnumToFillFormType1) {
        var gdefaultEnumFillFormDataType2 = gdefaultEnumFillFormDataType(dictGEnumToFillFormType1);
        return {
            gdefaultEnumFillFormDataType: function (v) {
                return tyUnion([ gdefaultEnumFillFormDataType1(Type_Proxy["Proxy"].value), gdefaultEnumFillFormDataType2(Type_Proxy["Proxy"].value) ]);
            }
        };
    };
};
var fillFormFieldTypeRecord = function (dict) {
    return dict.fillFormFieldTypeRecord;
};
var fillFormFieldType = function (dict) {
    return dict.fillFormFieldType;
};
var toRecordHelperConstructor = function (dictToRecordHelper) {
    var fillFormFieldType1 = fillFormFieldType(dictToRecordHelper.ToHelper0());
    var helperBaseClass1 = helperBaseClass(dictToRecordHelper);
    var toHelperClassBody1 = toHelperClassBody(dictToRecordHelper);
    return function (v) {
        var baseClass = Data_Maybe.fromMaybe(append1(lit("FormHelper<"))(append1(ppType(fillFormFieldType1(Type_Proxy["Proxy"].value)))(lit(">"))))(helperBaseClass1(Type_Proxy["Proxy"].value));
        return append1(lit("(class extends "))(append1(baseClass)(append1(lit("{"))(append1(toHelperClassBody1(Type_Proxy["Proxy"].value))(lit("})")))));
    };
};
var toRecordHelperRecord = function () {
    return function (dictRecordToHelper) {
        var toHelperRecord3 = toHelperRecord(dictRecordToHelper);
        return {
            helperBaseClass: function (v) {
                return Data_Maybe.Nothing.value;
            },
            toHelperClassBody: function (v) {
                return toHelperRecord3(Type_Proxy["Proxy"].value);
            },
            ToHelper0: function () {
                return toHelperRecord1()(dictRecordToHelper);
            }
        };
    };
};
var toHelperRecord1 = function () {
    return function (dictRecordToHelper) {
        var fillFormFieldTypeRecord1 = fillFormFieldTypeRecord(dictRecordToHelper);
        return {
            fillFormFieldType: function (v) {
                return tyRecord(fillFormFieldTypeRecord1(Type_Proxy["Proxy"].value));
            },
            toHelperConstructor: function (p) {
                return toRecordHelperConstructor(toRecordHelperRecord()(dictRecordToHelper))(p);
            }
        };
    };
};
var toRecordHelperRecord1 = /* #__PURE__ */ toRecordHelperRecord();
var toHelperRecord2 = /* #__PURE__ */ toHelperRecord1();
var toToplevelFormType = function (dictToHelper) {
    var fillFormFieldType1 = fillFormFieldType(dictToHelper);
    return function (name) {
        return append1(lit("export type " + (name + " = ")))(append1(ppType(fillFormFieldType1(Type_Proxy["Proxy"].value)))(lit(";")));
    };
};
var recordToHelperCons = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    return function (dictToHelper) {
        var fillFormFieldType1 = fillFormFieldType(dictToHelper);
        var toHelperConstructor1 = toHelperConstructor(dictToHelper);
        return function (dictRecordToHelper) {
            var fillFormFieldTypeRecord1 = fillFormFieldTypeRecord(dictRecordToHelper);
            var toHelperRecord3 = toHelperRecord(dictRecordToHelper);
            return {
                fillFormFieldTypeRecord: function (v) {
                    return Data_Array.cons(recordField(reflectSymbol(Type_Proxy["Proxy"].value))(fillFormFieldType1(Type_Proxy["Proxy"].value)))(fillFormFieldTypeRecord1(Type_Proxy["Proxy"].value));
                },
                toHelperRecord: function (v) {
                    var name = reflectSymbol(Type_Proxy["Proxy"].value);
                    return append1(lit("get " + (mangleName(name) + "() { return new ")))(append1(toHelperConstructor1(Type_Proxy["Proxy"].value))(append1(lit("(this.parent, this._name + '.' + " + (show(name) + "); }\x0a")))(toHelperRecord3(Type_Proxy["Proxy"].value))));
                }
            };
        };
    };
};
var recordToHelperCons1 = /* #__PURE__ */ recordToHelperCons({
    reflectSymbol: function () {
        return "_0";
    }
});
var recordToHelperCons2 = /* #__PURE__ */ recordToHelperCons({
    reflectSymbol: function () {
        return "_1";
    }
});
var recordToHelperCons3 = /* #__PURE__ */ recordToHelperCons({
    reflectSymbol: function () {
        return "__value__";
    }
});
var toHelperAutoForm$prime = function (dictIsAutoForm) {
    return function (dictToHelper) {
        var fillFormFieldType1 = fillFormFieldType(dictToHelper);
        var toHelperConstructor1 = toHelperConstructor(dictToHelper);
        return {
            fillFormFieldType: function (v) {
                return fillFormFieldType1(Type_Proxy["Proxy"].value);
            },
            toHelperConstructor: function (v) {
                return toHelperConstructor1(Type_Proxy["Proxy"].value);
            }
        };
    };
};
var toRecordHelperAutoForm$prime = function (dictIsAutoForm) {
    var toHelperAutoForm$prime1 = toHelperAutoForm$prime(dictIsAutoForm);
    return function () {
        return function (dictRecordToHelper) {
            var toRecordHelperRecord2 = toRecordHelperRecord1(dictRecordToHelper);
            var helperBaseClass1 = helperBaseClass(toRecordHelperRecord2);
            var toHelperClassBody1 = toHelperClassBody(toRecordHelperRecord2);
            return function (dictToHelper) {
                var toHelperAutoForm$prime2 = toHelperAutoForm$prime1(dictToHelper);
                return {
                    helperBaseClass: function (v) {
                        return helperBaseClass1(Type_Proxy["Proxy"].value);
                    },
                    toHelperClassBody: function (v) {
                        return toHelperClassBody1(Type_Proxy["Proxy"].value);
                    },
                    ToHelper0: function () {
                        return toHelperAutoForm$prime2;
                    }
                };
            };
        };
    };
};
var toHelperAutoVariantField$prime = function (dictIsAutoVariantField) {
    return function (dictToHelper) {
        var fillFormFieldType1 = fillFormFieldType(dictToHelper);
        var toHelperConstructor1 = toHelperConstructor(dictToHelper);
        return {
            fillFormFieldType: function (v) {
                return fillFormFieldType1(Type_Proxy["Proxy"].value);
            },
            toHelperConstructor: function (v) {
                return toHelperConstructor1(Type_Proxy["Proxy"].value);
            }
        };
    };
};
var toHelperLatched = function (dictToHelper) {
    var fillFormFieldType1 = fillFormFieldType(dictToHelper);
    var toHelperConstructor1 = toHelperConstructor(dictToHelper);
    return {
        fillFormFieldType: function (v) {
            return fillFormFieldType1(Type_Proxy["Proxy"].value);
        },
        toHelperConstructor: function (v) {
            return toHelperConstructor1(Type_Proxy["Proxy"].value);
        }
    };
};
var toHelperRecordField$prime = function (dictToHelper) {
    var fillFormFieldType1 = fillFormFieldType(dictToHelper);
    var toHelperConstructor1 = toHelperConstructor(dictToHelper);
    return {
        fillFormFieldType: function (v) {
            return fillFormFieldType1(Type_Proxy["Proxy"].value);
        },
        toHelperConstructor: function (v) {
            return toHelperConstructor1(Type_Proxy["Proxy"].value);
        }
    };
};
var toRecordHelperRecordField = function (dictToHelper) {
    var toHelperRecordField$prime1 = toHelperRecordField$prime(dictToHelper);
    return function () {
        return function (dictRecordToHelper) {
            var toHelperRecord3 = toHelperRecord(dictRecordToHelper);
            return {
                helperBaseClass: function (v) {
                    return Data_Maybe.Nothing.value;
                },
                toHelperClassBody: function (v) {
                    return toHelperRecord3(Type_Proxy["Proxy"].value);
                },
                ToHelper0: function () {
                    return toHelperRecordField$prime1;
                }
            };
        };
    };
};
var toRecordHelperT2 = function (dictToRecordHelper) {
    var recordToHelperCons5 = recordToHelperCons1(dictToRecordHelper.ToHelper0());
    return function (dictToRecordHelper1) {
        var toHelperClassBody1 = toHelperClassBody(toRecordHelperRecord1(recordToHelperCons5(recordToHelperCons2(dictToRecordHelper1.ToHelper0())(recordToHelperNil))));
        return {
            helperBaseClass: function (v) {
                return Data_Maybe.Nothing.value;
            },
            toHelperClassBody: function (v) {
                return toHelperClassBody1(Type_Proxy["Proxy"].value);
            },
            ToHelper0: function () {
                return toHelperT2(dictToRecordHelper)(dictToRecordHelper1);
            }
        };
    };
};
var toHelperT2 = function (dictToRecordHelper) {
    var recordToHelperCons5 = recordToHelperCons1(dictToRecordHelper.ToHelper0());
    return function (dictToRecordHelper1) {
        var fillFormFieldType1 = fillFormFieldType(toHelperRecord2(recordToHelperCons5(recordToHelperCons2(dictToRecordHelper1.ToHelper0())(recordToHelperNil))));
        return {
            fillFormFieldType: function (v) {
                return fillFormFieldType1(Type_Proxy["Proxy"].value);
            },
            toHelperConstructor: function (p) {
                return toRecordHelperConstructor(toRecordHelperT2(dictToRecordHelper)(dictToRecordHelper1))(p);
            }
        };
    };
};
var toRecordHelperWithExtra = function (dictToRecordHelper) {
    var helperBaseClass1 = helperBaseClass(dictToRecordHelper);
    var toHelperClassBody1 = toHelperClassBody(dictToRecordHelper);
    return function (dictToRecordHelper1) {
        var helperBaseClass2 = helperBaseClass(dictToRecordHelper1);
        var toHelperClassBody2 = toHelperClassBody(dictToRecordHelper1);
        return {
            helperBaseClass: function (v) {
                var v1 = helperBaseClass2(Type_Proxy["Proxy"].value);
                var v2 = helperBaseClass1(Type_Proxy["Proxy"].value);
                if (v2 instanceof Data_Maybe.Nothing) {
                    return v1;
                };
                if (v2 instanceof Data_Maybe.Just && v1 instanceof Data_Maybe.Nothing) {
                    return new Data_Maybe.Just(v2.value0);
                };
                if (v2 instanceof Data_Maybe.Just && v1 instanceof Data_Maybe.Just) {
                    return Partial_Unsafe.unsafeCrashWith("Error generating test helper: Multiple base classes for combined helper: " + (renderCode(v2.value0) + (", " + renderCode(v1.value0))));
                };
                throw new Error("Failed pattern match at Restaumatic.Form.TestHelpers (line 334, column 5 - line 338, column 142): " + [ v2.constructor.name, v1.constructor.name ]);
            },
            toHelperClassBody: function (v) {
                return append1(toHelperClassBody1(Type_Proxy["Proxy"].value))(append1(lit("\x0a"))(toHelperClassBody2(Type_Proxy["Proxy"].value)));
            },
            ToHelper0: function () {
                return toHelperWithExtra(dictToRecordHelper)(dictToRecordHelper1);
            }
        };
    };
};
var toHelperWithExtra = function (dictToRecordHelper) {
    var fillFormFieldType1 = fillFormFieldType(dictToRecordHelper.ToHelper0());
    return function (dictToRecordHelper1) {
        var fillFormFieldType2 = fillFormFieldType(dictToRecordHelper1.ToHelper0());
        return {
            fillFormFieldType: function (v) {
                return tyUnion([ fillFormFieldType1(Type_Proxy["Proxy"].value), fillFormFieldType2(Type_Proxy["Proxy"].value) ]);
            },
            toHelperConstructor: function (p) {
                return toRecordHelperConstructor(toRecordHelperWithExtra(dictToRecordHelper)(dictToRecordHelper1))(p);
            }
        };
    };
};
var toRecordHelperMapping = function (dictToRecordHelper) {
    var ToHelper0 = dictToRecordHelper.ToHelper0();
    var fillFormFieldType1 = fillFormFieldType(ToHelper0);
    var toHelperConstructor1 = toHelperConstructor(ToHelper0);
    return {
        helperBaseClass: function (v) {
            return new Data_Maybe.Just(append1(lit("ListHelper<"))(append1(ppType(fillFormFieldType1(Type_Proxy["Proxy"].value)))(lit(">"))));
        },
        toHelperClassBody: function (v) {
            return append1(lit("item(key: string) { return new "))(append1(toHelperConstructor1(Type_Proxy["Proxy"].value))(lit("(this.parent, this._name + '.' + key); }\x0a")));
        },
        ToHelper0: function () {
            return toHelperMapping(dictToRecordHelper);
        }
    };
};
var toHelperMapping = function (dictToRecordHelper) {
    var fillFormFieldType1 = fillFormFieldType(dictToRecordHelper.ToHelper0());
    return {
        fillFormFieldType: function (v) {
            return tyApp("FillFormList")([ fillFormFieldType1(Type_Proxy["Proxy"].value) ]);
        },
        toHelperConstructor: function (p) {
            return toRecordHelperConstructor(toRecordHelperMapping(dictToRecordHelper))(p);
        }
    };
};
var fillFormDataType = function (dict) {
    return dict.fillFormDataType;
};
var toToplevelType = function (dictToFillFormType) {
    var fillFormDataType1 = fillFormDataType(dictToFillFormType);
    return function (name) {
        return append1(lit("export type " + (name + " = ")))(append1(ppType(fillFormDataType1(Type_Proxy["Proxy"].value)))(lit(";")));
    };
};
var toFillFormTypeArray = function (dictToFillFormType) {
    var fillFormDataType1 = fillFormDataType(dictToFillFormType);
    return {
        fillFormDataType: function (v) {
            return tyArray(fillFormDataType1(Type_Proxy["Proxy"].value));
        }
    };
};
var toFillFormTypeMaybe = function (dictToFillFormType) {
    var fillFormDataType1 = fillFormDataType(dictToFillFormType);
    return {
        fillFormDataType: function (v) {
            return tyUnion([ tyVar("null"), fillFormDataType1(Type_Proxy["Proxy"].value) ]);
        }
    };
};
var toFillFormTypeMultiSet = function (dictToFillFormType) {
    var fillFormDataType1 = fillFormDataType(dictToFillFormType);
    return {
        fillFormDataType: function (v) {
            return tyArray(fillFormDataType1(Type_Proxy["Proxy"].value));
        }
    };
};
var toFillFormTypeMultiSet1 = function (dictToFillFormType) {
    var fillFormDataType1 = fillFormDataType(dictToFillFormType);
    return {
        fillFormDataType: function (v) {
            return tyArray(fillFormDataType1(Type_Proxy["Proxy"].value));
        }
    };
};
var toFillFormTypeOrderedMult = function (dictToFillFormType) {
    var fillFormDataType1 = fillFormDataType(dictToFillFormType);
    return {
        fillFormDataType: function (v) {
            return tyArray(fillFormDataType1(Type_Proxy["Proxy"].value));
        }
    };
};
var toFillFormTypeSet = function (dictToFillFormType) {
    var fillFormDataType1 = fillFormDataType(dictToFillFormType);
    return {
        fillFormDataType: function (v) {
            return tyArray(fillFormDataType1(Type_Proxy["Proxy"].value));
        }
    };
};
var toFillFormTypeSet1 = function (dictToFillFormType) {
    var fillFormDataType1 = fillFormDataType(dictToFillFormType);
    return {
        fillFormDataType: function (v) {
            return tyArray(fillFormDataType1(Type_Proxy["Proxy"].value));
        }
    };
};
var toFillFormTypeTranslated = function (dictToFillFormType) {
    var fillFormDataType1 = fillFormDataType(dictToFillFormType);
    return {
        fillFormDataType: function (v) {
            return fillFormDataType1(Type_Proxy["Proxy"].value);
        }
    };
};
var toHelperFormField$prime = function (dictToFillFormType) {
    var fillFormDataType1 = fillFormDataType(dictToFillFormType);
    return {
        fillFormFieldType: function (v) {
            return fillFormDataType1(Type_Proxy["Proxy"].value);
        },
        toHelperConstructor: function (v) {
            return append1(lit("FieldHelper<"))(append1(ppType(fillFormDataType1(Type_Proxy["Proxy"].value)))(lit(">")));
        }
    };
};
var recordToHelperCons4 = /* #__PURE__ */ recordToHelperCons({
    reflectSymbol: function () {
        return "__exists__";
    }
})(/* #__PURE__ */ toHelperFormField$prime(toFillFormTypeBoolean));
var toHelperOptionalField$prime = function (dictToHelper) {
    var toHelperRecord3 = toHelperRecord2(recordToHelperCons4(recordToHelperCons3(dictToHelper)(recordToHelperNil)));
    var fillFormFieldType1 = fillFormFieldType(toHelperRecord3);
    var toHelperConstructor1 = toHelperConstructor(toHelperRecord3);
    return {
        fillFormFieldType: function (v) {
            return fillFormFieldType1(Type_Proxy["Proxy"].value);
        },
        toHelperConstructor: function (v) {
            return toHelperConstructor1(Type_Proxy["Proxy"].value);
        }
    };
};
var toHelperVariantField$prime = function () {
    return function (dictRecordToHelper) {
        var fillFormFieldTypeRecord1 = fillFormFieldTypeRecord(dictRecordToHelper);
        var toHelperRecord3 = toHelperRecord(dictRecordToHelper);
        return function (dictToFillFormType) {
            var fillFormDataType1 = fillFormDataType(dictToFillFormType);
            return {
                fillFormFieldType: function (v) {
                    return tyRecord(Data_Array.cons(recordField("tag")(fillFormDataType1(Type_Proxy["Proxy"].value)))(fillFormFieldTypeRecord1(Type_Proxy["Proxy"].value)));
                },
                toHelperConstructor: function (v) {
                    return append1(lit("(class extends FormHelper<"))(append1(ppType(fillFormFieldType(toHelperVariantField$prime()(dictRecordToHelper)(dictToFillFormType))(Type_Proxy["Proxy"].value)))(append1(lit(">{"))(append1(lit("get tag() { return new FieldHelper<"))(append1(ppType(fillFormDataType1(Type_Proxy["Proxy"].value)))(append1(lit(">(this.parent, this._name + '.tag'); }\x0a"))(append1(toHelperRecord3(Type_Proxy["Proxy"].value))(lit("})"))))))));
                }
            };
        };
    };
};
var toRecordHelperFormField$prime = function (dictToFillFormType) {
    var fillFormDataType1 = fillFormDataType(dictToFillFormType);
    var toHelperFormField$prime1 = toHelperFormField$prime(dictToFillFormType);
    return {
        helperBaseClass: function (v) {
            return new Data_Maybe.Just(append1(lit("FieldHelper<"))(append1(ppType(fillFormDataType1(Type_Proxy["Proxy"].value)))(lit(">"))));
        },
        toHelperClassBody: function (v) {
            return mempty;
        },
        ToHelper0: function () {
            return toHelperFormField$prime1;
        }
    };
};
var defaultEnumFillFormDataType = function (dictGeneric) {
    return function (dictGEnumToFillFormType) {
        var gdefaultEnumFillFormDataType1 = gdefaultEnumFillFormDataType(dictGEnumToFillFormType);
        return function (v) {
            return gdefaultEnumFillFormDataType1(Type_Proxy["Proxy"].value);
        };
    };
};
export {
    fillFormDataType,
    fillFormFieldType,
    fillFormFieldTypeRecord,
    gdefaultEnumFillFormDataType,
    helperBaseClass,
    toHelperClassBody,
    toHelperConstructor,
    toHelperRecord,
    TSType,
    renderType,
    TSRecordField,
    recordField,
    tyVar,
    tyRecord,
    tyUnion,
    tyIntersection,
    tyApp,
    tyStringConstant,
    tyArray,
    Code,
    lit,
    ppType,
    renderCode,
    toToplevelHelper,
    toToplevelFormType,
    toToplevelType,
    mangleName,
    toRecordHelperConstructor,
    defaultEnumFillFormDataType,
    semigroupCode,
    monoidCode,
    toHelperFormField$prime,
    toRecordHelperFormField$prime,
    toHelperReadOnly$prime,
    toHelperAction,
    toHelperExclusiveTask,
    toHelperAsync,
    toHelperLatched,
    toHelperPaginator,
    toHelperRecordField$prime,
    toRecordHelperRecordField,
    toHelperRecord1,
    toRecordHelperRecord,
    toHelperAutoForm$prime,
    toRecordHelperAutoForm$prime,
    recordToHelperNil,
    recordToHelperCons,
    toHelperVariantField$prime,
    toHelperAutoVariantField$prime,
    toHelperMapping,
    toRecordHelperMapping,
    toHelperWithExtra,
    toRecordHelperWithExtra,
    toHelperT2,
    toRecordHelperT2,
    toHelperOptionalField$prime,
    toFillFormTypeInt,
    toFillFormTypeBoolean,
    toFillFormTypeString,
    toFillFormTypeLocale,
    toFillFormTypeMoney,
    toFillFormTypeRational,
    toFillFormTypeCoordinates,
    toFillFormTypeUnit,
    toFillFormTypeSet,
    toFillFormTypeSet1,
    toFillFormTypeMultiSet,
    toFillFormTypeMultiSet1,
    toFillFormTypeMaybe,
    toFillFormTypeEntityId,
    toFillFormTypeTranslated,
    toFillFormTypeMap,
    toFillFormTypeMap1,
    toFillFormTypeOMap,
    toFillFormTypeOrderedMult,
    toFillFormTypeOption,
    toFillFormTypeArray,
    toFillFormTypeAction,
    toFillFormTypeForeign,
    toFillFormTypeValue,
    toFillFormTypeTag,
    gEnumToFillFormTypeConstr,
    gEnumToFillFormTypeSum
};
